/**  Тип проперти в декларации. */
export enum OperationInitTypes {
  /** Новая.*/
  New = 0,

  /** По шаблону. */
  ByTemplate = 1,

  /** Повтор операции. */
  Repeat = 2
}
